/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetShiftsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getShifts = (request: GetShiftsRequest, options?: CashRequestOptions) => post<GetShiftsRequest, GetShiftsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetShifts", request, {...options, rejectOnError: true })